/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'underscore',
	'react',
	'react-dom',
	'./textFormatDialog/TextFormatComponent'
], function (View, _, React, ReactDOM, TextFormatComponent) {


	/**
	 * @classdesc  Creates a text dialog
	 *
	 * @public
	 * @callback callback
	 * @param {object} options.eventHandler - Event handler
	 * @param {object} [options.state] - If you want to pass the existing text format state
	 */
	class TextFormatDialog extends View {

		constructor(...args) {
			super(...args);

			const options = args && args[0];
			this._okHandler = options.actions.apply;
			this._closeHandler = options.actions.close;

			//TODO: ignoring height and width for now
			this._state = options.state.currentState;
			this._properties = options.state.properties;
			this._elementListType = options.state.elementListType;
			this._supportsTextWrap = options.state.supportsTextWrap;

			this._iWidth = '305';
		}

		remove() {
			if (this.$el) {
				ReactDOM.unmountComponentAtNode(this.$el[0]);
			}
			this.viewState = null;
			return super.remove();
		}

		render() {
			this.$el
				.addClass('popoverTBDialogContainer textDialog')
				.width(this._iWidth + 'px');

			//Note: TextFormatDialog is not a React component, so unlike all the other render()s in this file,
			//this will NOT rerender when its internal state changes. So, these properties are only initial values.
			this.reactComponents = ReactDOM.render(
				<TextFormatComponent
					state={this._state}
					supportsStyleAndAlignment={this._elementListType !== 'simpleTextEdit'}
					supportsTextWrap={this._supportsTextWrap}
					colorOptions={this._properties.colors}
					fontOptions={this._properties.fonts}
					fontSizeOptions={this._properties.fontSizes}
					defaultState={this._properties.defaultState}
					onStateChange={state => this._newState(state)}
					onClose={() => this._close()}
				/>,
				this.$el[0]
			);

			return this;
		}

		_newState(state) {
			this._okHandler(state);
		}

		_close() {
			this._closeHandler();
			this.remove();
		}
	}

	return TextFormatDialog;
});
